/**
 * Fixed Nav Component
 */

import initialiser from '../../utils/initialiser';

const defaultSettings = {
  fixedPositionClass: 'fixed-nav',
};

class FixedNav {
  constructor(config) {
    const { el, settings } = config;

    // Set module dom elements
    this.container = el;

    // Set settings
    this.settings = { ...defaultSettings, ...settings };
    this.selector = document.querySelector(settings.selector);
  }

  // Initialisation Function
  init = () => {
    if (!this.selector) return;
    window.addEventListener('scroll', this.bindEvents);
  };

  bindEvents = () => {
    const bottomOfHero = this.selector.offsetTop + this.selector.offsetHeight;

    if (window.scrollY >= bottomOfHero) {
      document.body.classList.remove(this.settings.fixedPositionClass);
    } else {
      document.body.classList.add(this.settings.fixedPositionClass);
    }
  };
}

export default (settings) => initialiser(settings, FixedNav);
